import { createSelector } from '@reduxjs/toolkit';

//📌 Selector for get all team from current profile.
export const selectTeams = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID],
	(teamsData, orgID) => teamsData[orgID] || []
);

//📌 Selector for get all teams by SiteID
export const selectTeamsBySiteID = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID, (_state, siteID) => siteID],
	(teamsData, orgID, siteID) => {
		return (teamsData[orgID] || []).filter((team) => team.siteID === siteID) || null;
	}
);

// 📌 Selector to get all teams where the current personID is a member.
export const selectTeamsByPersonID = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID, (_, personID) => personID],
	(teamsData, orgID, personID) => {
		const teams = teamsData[orgID] || [];

		// 🔥 Filter out teams where the personID is NOT a member
		return teams.filter((team) => team.members?.includes(personID));
	}
);

//📌 Selector for get team by teamID.
export const selectTeamsByTeamID = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID, (_, teamID) => teamID],
	(teamsData, orgID, teamID) => (teamsData[orgID] || []).find((team) => team.teamID === teamID) || null
);

//📌 Selector for get all teams by name.
export const selectTeamsByName = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID, (_, name) => name],
	(teamsData, orgID, name) =>
		(teamsData[orgID] || []).filter((team) => team.name.toLowerCase().includes(name.toLowerCase())) || []
);
// 📌 Selector for the last created team in the current org
export const selectLastCreatedTeam = createSelector(
	[(state) => state.Teams.data, (state) => state.Auth.selectedProfile.orgID],
	(teamsData, orgID) => {
		const teams = teamsData[orgID] || [];
		return teams.length > 0 ? teams[teams.length - 1] : null;
	}
);
